import React from 'react';
import {useTranslation} from 'next-i18next';
import {isAdmin} from '@deezer/next/shared/utils/user';
import {useUser} from '@deezer/next/contexts/main/hooks';
import NavigationLayout from '@deezer/next/shared/layouts/NavigationLayout';
import UserForm from '@deezer/next/features/Account/components/UserForm';
import {getServerSideTranslationsWrapper} from '@deezer/next/shared/utils/next';

const MyProfile = () => {
	const {t} = useTranslation('d4c');
	const user = useUser();

	if (!user) return null;

	return (
		<UserForm
			title={t('usermanager_title_editaccount_d4c-web')}
			user={user}
			isEditAllowed={isAdmin(user)}
			isCurrentUser={true}
			action={'edit'}
		/>
	);
};

MyProfile.getLayout = (page: React.ReactElement) => {
	return <NavigationLayout>{page}</NavigationLayout>;
};

export const getStaticProps = getServerSideTranslationsWrapper(() => {
	return {
		props: {
			logged: true,
			mode: 'light',
		},
	};
});

export default MyProfile;
